import { CheckBoxProps, CheckBox as SerendieCheckBox } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import "./Styles.scss";

export class CheckBox extends BaseComponent<ICheckBoxProps, ICheckBoxState>
{
    public render(): JSX.Element
    {
        return <SerendieCheckBox
            {...this.props}
            className={`${this.props.className ?? ''} serendie-checkbox`}
        />
    }
}

export interface ICheckBoxProps extends CheckBoxProps { }
export interface ICheckBoxState { }
